// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__S38ck","label":"styles_label__iF2sB","icon":"styles_icon__cNzlJ"};